import React from "react";

import { Callout, Modal, ModalProps, Text } from "@examspark/common-ui";
import { IconCautionSolid } from "@examspark/common-ui/dist/components/icons";
import { PaddedBody } from "@examspark/common-ui/dist/components/modals/Modal";

const DeletedCalendarInfoModal = (props: ModalProps) => {
  return (
    <Modal size="small" title="Calendar Unavailable" {...props}>
      <PaddedBody>
        <Callout icon={<IconCautionSolid fill="orange" width="16" />}>
          <Text.Body>
            <p>
              The course calendar used by this classroom has been deleted or
              archived by an administrator.
            </p>
            <p>
              You may continue using this calendar, but it is recommended that
              you switch to another calendar in the classroom settings.
            </p>
          </Text.Body>
        </Callout>
      </PaddedBody>
    </Modal>
  );
};
export default DeletedCalendarInfoModal;
